module.exports = __webpack_public_path__ + "media/images/top-page_reserve_sp@2x-e7c147540cfa44e2aea68abdf30edec2.jpg";